import { FormattedNumber } from 'react-intl';

type Props = {
  count: number;
  isAtLeast?: boolean;
  /**
   * @default 1_000_000
   */
  limit?: number;
};

const MAX_JOB_COUNT = 1_000_000;

// This helper hides the count if bigger than 1_000_000,
// to prevent the disclosure of our real job inventory count (product decision)
export const LimitedJobCount: React.FC<Props> = ({
  count,
  isAtLeast = false,
  limit = MAX_JOB_COUNT,
}) => {
  const isLimited = count > limit;

  return (
    <>
      <FormattedNumber value={isLimited ? limit : count} />
      {isLimited || isAtLeast ? '+' : null}
    </>
  );
};
